<template>
<header>
  <section>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class='container'>
  <a class="navbar-brand" href="/">SCaPP</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNav">
    <ul class="navbar-nav">
      <li class="nav-item" :class="{'active': selected=='home'}">
        <router-link to="/home" class="nav-link" >Home</router-link> 
      </li>
      <li class="nav-item" :class="{'active': selected=='personeel'}">
        <router-link to="/employees" class="nav-link">Medewerkers</router-link>
      </li>
      <li class="nav-item" :class="{'active': selected=='publications'}">
        <router-link to="/news" class="nav-link">Nieuws</router-link>
      </li>
      <li class="nav-item" :class="{'active': selected=='documents'}">
        <router-link to="/documents" class="nav-link">Documenten</router-link>
      </li>
      <li class="nav-item" :class="{'active': selected=='calendar'}">
        <router-link to="/calendar" class="nav-link">Agenda</router-link>
      </li>
      <li class="nav-item" :class="{'active': selected=='notifications'}">
        <router-link to="/notifications" class="nav-link">Notificaties</router-link>
      </li>
      <li class="nav-item" :class="{'active': selected=='establishments'}">
        <router-link to="/establishments" class="nav-link">Vestigingen</router-link>
      </li>
    </ul>   
  </div>   
      <a href="#" @click="logout">uitloggen</a>
    </div>
</nav>
  </section>
</header>
</template>





<script>
const fb = require('../firebaseConfig.js')
export default {
  name: 'Navbar',
  props: {
    selected: String
  },
    methods: {
      logout: function(){
        fb.auth.signOut().then(()=>{
          this.$store.dispatch('clearData');
          this.$router.replace('login');
        });
      }
    }
}
</script>


<style scoped>
#navbar {
  width: 80%;

}
</style>